import React from 'react';
import {
  ActionButton,
  ActionButtonBedge,
  ActionButtonWrap,
  MobileActionBtnWrap,
} from './actionBarStyle';
import Icon from '@components/dataDisplay/Icons/Icon';
import Tooltip from '@components/dataDisplay/Tooltip';
import {
  TOOLTIP_DIR_TYPE,
  TOOLTIP_DIR_TYPE_VALUE,
} from '@typings/common/tooltipDirType';
import useWindowWidth from '@hooks/useWindowWidth';
import IconButton from '@components/dataEntry/button/IconButton';
import Color from '@styles/Color';

export enum actionTypeEnum {
  COMMENT = 'comment',
  BOOKMARK = 'bookmark',
  SERIES = 'series',
}

const variants = {
  initial: { opacity: 0, y: 50 },
  hidden: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 0.2,
    },
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.6,
    },
  },
  exit: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 0.2,
    },
  },
};

type Props = {
  showWide?: boolean;
  commentCount: number;
  onClick: (actionType) => void;
  dir?: 'vertical' | 'horizontal';
  transparent?: boolean;
  isBookmark: boolean;
  tooltipDir?: TOOLTIP_DIR_TYPE_VALUE;
  showComment?: boolean;
  goPrev?: () => void;
  goNext?: () => void;
  showActionBar?: boolean;
};

function ActionBar({
  showWide,
  commentCount,
  onClick,
  dir = 'horizontal',
  transparent,
  isBookmark,
  tooltipDir = TOOLTIP_DIR_TYPE.BOTTOM,
  showComment,
  goPrev,
  goNext,
  showActionBar,
}: Props) {
  const isMobile = useWindowWidth() < 480;
  if (showWide || isMobile) {
    return (
      <MobileActionBtnWrap
        initial="initial"
        animate={showActionBar ? 'show' : 'hidden'}
        exit="exit"
        variants={variants}
      >
        <div className="group">
          <IconButton
            iconColor={Color.BLUE_GRAY_1}
            icon="HeartF"
            shape="default"
            onClick={() => onClick(actionTypeEnum.BOOKMARK)}
          />
          <IconButton
            iconColor={Color.BLUE_GRAY_1}
            icon="TalkF"
            shape="default"
            onClick={() => onClick(actionTypeEnum.COMMENT)}
            style={{ width: 'auto', minWidth: 'auto' }}
          >
            <span style={{ color: Color.BLUE_GRAY_1, paddingLeft: 8 }}>
              {commentCount}
            </span>
          </IconButton>
        </div>

        <div className="group">
          <IconButton
            iconColor={Color.BLUE_GRAY_1}
            icon="LeftArrowO"
            shape="default"
            onClick={goPrev}
          />
          <IconButton
            iconColor={Color.BLUE_GRAY_1}
            icon="SeriesF"
            shape="default"
            onClick={() => onClick(actionTypeEnum.SERIES)}
          />
          <IconButton
            iconColor={Color.BLUE_GRAY_1}
            icon="RightArrowO"
            shape="default"
            onClick={goNext}
          />
        </div>
      </MobileActionBtnWrap>
    );
  } else {
    return (
      <>
        <ActionButtonWrap dir={dir} transparent={transparent}>
          {showComment && (
            <Tooltip message="댓글" direction={tooltipDir} hidden={!tooltipDir}>
              <ActionButton onClick={() => onClick(actionTypeEnum.COMMENT)}>
                <ActionButtonBedge>
                  <span>{commentCount}</span>
                </ActionButtonBedge>
                <Icon name="TalkF" />
              </ActionButton>
            </Tooltip>
          )}
          <Tooltip
            message="시리즈 목록"
            direction={tooltipDir}
            hidden={!tooltipDir}
          >
            <ActionButton onClick={() => onClick(actionTypeEnum.SERIES)}>
              <Icon name="SeriesF" />
            </ActionButton>
          </Tooltip>
          <Tooltip message="북마크" direction={tooltipDir} hidden={!tooltipDir}>
            <ActionButton onClick={() => onClick(actionTypeEnum.BOOKMARK)}>
              <Icon
                name="HeartF"
                color={
                  isBookmark ? 'var(--primaryColor)' : 'var(--subTextColor)'
                }
              />
            </ActionButton>
          </Tooltip>
        </ActionButtonWrap>
      </>
    );
  }
}

export default ActionBar;
